import { render, staticRenderFns } from "./Friend.vue?vue&type=template&id=3c2e37b2&scoped=true"
import script from "./Friend.vue?vue&type=script&lang=js"
export * from "./Friend.vue?vue&type=script&lang=js"
import style0 from "./Friend.vue?vue&type=style&index=0&id=3c2e37b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../T88/build-source/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e37b2",
  null
  
)

export default component.exports